<template>
	<v-card>
		<v-toolbar flat color="dark" dark>
			<v-toolbar-title>
				<span class="pl-2">Kleuren codering</span>
			</v-toolbar-title>
		</v-toolbar>
		<v-card-title class="pb-0 pt-4 flex-wrap">
			<v-text-field
				v-model="search"
				append-icon="mdi-magnify"
				label="Zoeken"
				single-line
				hide-details
				dense
				class="flex-grow-1 mb-2"
				style="min-width: 200px"
			></v-text-field>
		</v-card-title>

		<v-alert v-if="loadError" type="error" dense outlined class="mx-4 mb-0">
			{{ loadError }}
		</v-alert>

		<v-data-table
			:headers="headers"
			:items="data"
			:search="search"
			:loading="loading"
			class="elevation-0"
		>
			<template v-slot:top>
				<v-toolbar dark dense color="primary" flat class="mb-1">
					<v-btn depressed class="ml-2" color="inverted" @click="goNew">
						<v-icon class="pr-2">mdi-plus-circle</v-icon>
						Nieuwe kleurcode
					</v-btn>
				</v-toolbar>
			</template>
			<template v-slot:item.action="{ item }">
				<v-icon color="primary" class="mr-2" style="cursor: pointer" @click="goEdit(item.id)">
					mdi-pencil
				</v-icon>
				<v-icon color="error" style="cursor: pointer" @click="confirmDelete(item)">
					mdi-delete
				</v-icon>
			</template>
			<template v-slot:item.swatch="{ item }">
				<span class="activity-swatch activity-swatch--wide" :style="activitySwatchStyle(item)"></span>
			</template>
			<template v-slot:item.for_personnel="{ item }">
				<v-chip x-small :color="isOn(item.for_personnel) ? 'success' : 'grey'" text-color="white">
					{{ isOn(item.for_personnel) ? "Ja" : "Nee" }}
				</v-chip>
			</template>
			<template v-slot:item.for_student="{ item }">
				<v-chip x-small :color="isOn(item.for_student) ? 'success' : 'grey'" text-color="white">
					{{ isOn(item.for_student) ? "Ja" : "Nee" }}
				</v-chip>
			</template>
		</v-data-table>

		<v-dialog v-model="deleteDialog" max-width="440">
			<v-card>
				<v-card-title class="headline">Kleurcode verwijderen?</v-card-title>
				<v-card-text>
					Weet u zeker dat u
					<strong>{{ deleteTarget && deleteTarget.name }}</strong>
					wilt verwijderen?
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text @click="deleteDialog = false">Annuleren</v-btn>
					<v-btn color="error" depressed :loading="deleting" @click="doDelete">Verwijderen</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-card>
</template>

<script>
import Axios from "axios";
import { API_ROOT } from "../../config";
import { activitySwatchStyle } from "../../constants/schoolyearPlanningActivities";

const ax = Axios.create({
	baseURL: API_ROOT["osbod_salary"],
	timeout: 60000
});

export default {
	name: "SchoolyearPlanningActivities",
	data() {
		return {
			search: "",
			loading: false,
			loadError: "",
			data: [],
			deleteDialog: false,
			deleting: false,
			deleteTarget: null,
			headers: [
				{ text: "", align: "center", sortable: false, value: "action" },
				{ text: "ID", value: "id" },
				{ text: "Voorbeeld", value: "swatch", sortable: false },
				{ text: "Naam", value: "name" },
				{ text: "Personeel", value: "for_personnel" },
				{ text: "Student", value: "for_student" },
				{ text: "Code", value: "code" },
				{ text: "Kleur", value: "color" },
				{ text: "Patroon", value: "pattern" }
			]
		};
	},
	created() {
		this.fetchItems();
	},
	methods: {
		activitySwatchStyle: activitySwatchStyle,
		isOn(value) {
			return value != null && Number(value) === 1;
		},
		goNew() {
			this.$router.push({ path: "/schooladmin/schoolyear_planning_activities/new" });
		},
		goEdit(id) {
			this.$router.push({
				path: "/schooladmin/schoolyear_planning_activities/update/" + id
			});
		},
		confirmDelete(item) {
			this.deleteTarget = item;
			this.deleteDialog = true;
		},
		doDelete() {
			var self = this;
			if (!self.deleteTarget || self.deleteTarget.id == null) return;
			self.deleting = true;
			self.loadError = "";
			ax.post("/schoolyear_planning/activities/delete/" + self.deleteTarget.id)
				.then(function() {
					self.deleteDialog = false;
					self.deleteTarget = null;
					self.fetchItems();
				})
				.catch(function(err) {
					self.loadError =
						(err &&
							err.response &&
							err.response.data &&
							err.response.data.msg) ||
						"Verwijderen mislukt.";
					self.deleteDialog = false;
				})
				.finally(function() {
					self.deleting = false;
				});
		},
		fetchItems() {
			var self = this;
			self.loading = true;
			self.loadError = "";
			ax.get("/schoolyear_planning/activities")
				.then(function(res) {
					self.data = Array.isArray(res.data) ? res.data : [];
				})
				.catch(function(err) {
					self.loadError =
						(err &&
							err.response &&
							err.response.data &&
							err.response.data.msg) ||
						"Kleuren codering kon niet worden geladen.";
					self.data = [];
				})
				.finally(function() {
					self.loading = false;
				});
		}
	}
};
</script>

<style scoped>
.activity-swatch {
	display: inline-block;
	width: 28px;
	height: 18px;
	border-radius: 2px;
	vertical-align: middle;
}
.activity-swatch--wide {
	width: 72px;
	height: 22px;
}
</style>
